import { DatePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DomainTraditionReportType, PrintType, ReimbursementOperation } from '../@core/constants';
import { PosSupervisorLoginService } from '../@core/services/pos-supervisor-login.service';
import { Filter } from '../models/filter';
import { ReplicateInformationFilter } from '../models/filters/replicate-information-filter';
import { AuthService } from './auth.service';
import { ConfigurationService } from './configuration.service';
import Swal from 'sweetalert2';
import { ExceptionSolutionService } from './exception-solution.service';
@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private http: HttpClient, private configService: ConfigurationService, private supervisorService: PosSupervisorLoginService, private authService: AuthService, private router: Router, private datePipe: DatePipe,
    private exceptionSolutionService: ExceptionSolutionService
  ) { }

  ip800RequestPdf(code: string) {
    let params = new HttpParams().set("pdf", "true").set("code", code).set("salesOrg", this.configService.readSelectedBranchAndSalesOrg().salesOrg.code);
    return this.http.get<Blob>(`${environment.url}/ip800request/pdf`, { params });
  }

  invoicePdf(code: string, salesOrgCode: string) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("salesOrgCode", salesOrgCode)
      .set("type", PrintType.ORIGINAL);

    return this.http.get<Blob>(`${environment.url}/invoices/${code}`, { params });
  }

  invoiceCopyPdf(code: string, salesOrgCode: string) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("salesOrgCode", salesOrgCode)
      .set("type", PrintType.COPY);

    return this.http.get<Blob>(`${environment.url}/invoices/${code}`, { params });
  }

  loanPdf(code: string, salesOrgCode: string) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("salesOrg", salesOrgCode)
      .set("code", code);
    return this.http.get<Blob>(`${environment.url}/loans/getPdf`, { params });
  }

  receiptPdf(code: string) {
    let params = new HttpParams()
      .set("pdf", "true")
    return this.http.get<Blob>(`${environment.url}/receipts/${code}`, { params });
  }

  debitNotePdf(code: string, salesOrgCode: string) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("salesOrg", salesOrgCode)
      .set("printType", "ORIGINAL");

    return this.http.get<Blob>(`${environment.url}/debitNote/${code}`, { params });
  }

  quotationPDF(orderCorde: string, salesOrgCode: string, loanCode?: string) {
    let params = new HttpParams().set("pdf", "true").set("quotationCode", orderCorde).set("salesOrg", salesOrgCode);
    params = loanCode ? params.set("loanCode", loanCode) : params;
    return this.http.get<Blob>(`${environment.url}/quotation`, { params });
  }

  promissoryNotePdf(contractNumber: string, salesOrgCode: string) {
    let params = new HttpParams().set("pdf", "true").set("contractNo", contractNumber).set("salesOrg", salesOrgCode);
    return this.http.get<Blob>(`${environment.url}/promissoryNote`, { params });
  }

  paymentPlanFinancedPdf(contractNumber: string, salesOrgCode: string) {
    let params = new HttpParams().set("pdf", "true").set("contractNo", contractNumber).set("salesOrg", salesOrgCode).set("deliveryType", "ACREDITACIÓN A CUENTA")
    return this.http.get<Blob>(`${environment.url}/paymentPlan/finaced`, { params });
  }

  paymentPlanPdf(contractNumber: string, salesOrgCode: string) {
    let params = new HttpParams().set("pdf", "true").set("contractNo", contractNumber).set("salesOrg", salesOrgCode).set("deliveryType", "ACREDITACIÓN A CUENTA")
    return this.http.get<Blob>(`${environment.url}/paymentPlan`, { params });
  }

  checklistPdf(invoiceCode: string, salesOrgCode: string) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("invoiceCode", invoiceCode)
      .set("salesOrg", salesOrgCode);
    return this.http.get<Blob>(`${environment.url}/checklist/pdf`, { params });
  }

  productDeliveryPdf(code: string) {
    let params = new HttpParams()
      .set("pdf", "true");
    return this.http.get<Blob>(`${environment.url}/productDeliveryReport/${code}`, { params });
  }

  productVerificationPdf(code: string) {
    let params = new HttpParams()
      .set("pdf", "true");
    return this.http.get<Blob>(`${environment.url}/productVerificationReport/${code}`, { params });
  }

  releaseOfResponsibilityReportPdf(code: string) {
    let params = new HttpParams()
      .set("pdf", "true");
    return this.http.get<Blob>(`${environment.url}/releaseOfResponsibilityReport/${code}`, { params });
  }


  domainTraditionPdf(invoiceCode: string, salesOrgCode: string, type: DomainTraditionReportType) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("invoiceCode", invoiceCode)
      .set("salesOrg", salesOrgCode)
      .set("reportType", type);
    return this.http.get<Blob>(`${environment.url}/dominanceTradition`, { params });
  }

  thirdPartyAuthorizationPdf(invoiceNumber: string, identity: string, name: string, salesOrgCode: string) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("invoiceNo", invoiceNumber)
      .set("salesOrg", salesOrgCode)
      .set("thirdPartyName", name)
      .set("thirdPartyId", identity);
    return this.http.get<Blob>(`${environment.url}/ip800request/thirdPartyAuthorizationPdf`, { params });
  }

  registrationRefusalPdf(invoiceCode: string, location: string, salesOrgCode: string) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("invoiceCode", invoiceCode)
      .set("salesOrg", salesOrgCode)
      .set("location", location);
    return this.http.get<Blob>(`${environment.url}/ip800request/voluntaryRegistrationRefusalPdf`, { params });
  }

  itemReservationPdf(receiptCode: string, salesOrgCode: string, accessToken?: string) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("receiptCode", receiptCode)
      .set("salesOrgCode", salesOrgCode);
    return this.http.get<Blob>(`${environment.url}/itemReservation`, { params });
  }

  printItemLiquidation(advanceCode: string) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("advanceCode", advanceCode)
      .set("salesOrgCode", this.configService.readSelectedBranchAndSalesOrg().salesOrg.code)
      .set("branchCode", this.configService.readSelectedBranchAndSalesOrg().branch.code);

    return this.http.get<Blob>(`${environment.url}/itemReservationLiquidation`, { params });
  }
  registerClose(code: string, salesOrgCode: string) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("salesOrg", salesOrgCode);

    return this.http.get<Blob>(`${environment.url}/registers/close/${code}`, { params })
  }

  warrantyCertificate(invoiceCode: string, salesOrgCode: string) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("salesOrgCode", salesOrgCode)
      .set("invoiceCode", invoiceCode);

    return this.http.get<Blob>(`${environment.url}/warrantyCertificate`, { params });
  }

  printContractReferral(fromDate: string, toDate: string, salesOrgCode: string, branchCode: string) {

    let params = new HttpParams()
      .set("pdf", "true")
      .set("salesOrg", salesOrgCode)
      .set("fromDate", fromDate)
      .set("toDate", toDate)
      .set("branchCode", branchCode)

    return this.http.get<Blob>(`${environment.url}/contractReferral`, { params });
  }

  circulationPermit(code: string, salesOrgCode: string) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("code", code)
      .set("salesOrg", salesOrgCode);

    return this.http.get<Blob>(`${environment.url}/circulationPermit/pdf/`, { params });
  }

  digitalSignaturePrintPDF(requestCode: string, documentCode: string) {
    let params = new HttpParams()
      .set("pdf", "true");
    return this.http.get<Blob>(`${environment.url}/orders/document/${documentCode}/request/${requestCode}`, { params });
  }

  purchaseOrderPdf(orderCode: string) {
    let params = new HttpParams()
      .set("pdf", "true");
    return this.http.get<Blob>(`${environment.url}/purchaseOrder/${orderCode}`, { params });
  }

  ip800PDF(code: string, salesOrgCode: string) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("code", code)
      .set("salesOrg", salesOrgCode);

    return this.http.get<Blob>(`${environment.url}/ip800request/pdf`, { params });
  }

  promisoryNotePdf(contractNo: string, salesOrgCode: string) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("salesOrg", salesOrgCode)
      .set("contractNo", contractNo);
    return this.http.get<Blob>(`${environment.url}/promissoryNote`, { params });
  }


  printReport(blob: Blob): Promise<void> {
    return new Promise((resolve, reject) => {
      let fileURL = URL.createObjectURL(blob);

      window.open(fileURL);
    })
  }

  printReports(...blobs: Blob[]): Promise<void> {
    if (blobs.length == 0) {
      return new Promise((resolve, reject) => { resolve() });
    }
    return new Promise((resolve, reject) => {
      blobs.forEach(blob => {
        if (blob.size > 0) {

          let fileURL = URL.createObjectURL(blob);
          window.open(fileURL);

          resolve();
        }
      })
    })
  }


  async printReportsSupervisor(privileges: Array<string>, ...blobs: Blob[]): Promise<void> {

    let user = (await this.authService.readProfileInStorage());
    if (await this.authService.hasPrivilegesInRoles(user.roles, new Set(privileges))) {
      await this.printReports(...blobs);
    }
    else if (blobs.length > 0) {
      await this.supervisorService.show(async () => {
        await this.printReports(...blobs);
      }, privileges);
    }
  }

  extraWarrantyCertificate(invoiceCode: string, orderEntryListIndex: string, salesOrgCode: string) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("invoiceCode", invoiceCode)
      .set("orderEntryListIndex", orderEntryListIndex)
      .set('salesOrg', salesOrgCode);
    return this.http.get<Blob>(`${environment.url}/extraWarranty`, { params });
  }

  creditNotePdf(creditNoteCode: string, salesOrgCode: string) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("creditNoteCode", creditNoteCode)
      .set('salesOrg', salesOrgCode);

    return this.http.get<Blob>(`${environment.url}/creditnote/retail`, { params });
  }

  voucherPdf(voucherCode: string) {

    let params = new HttpParams()
      .set("pdf", "true")
      .set("voucherCode", voucherCode);
    return this.http.get<Blob>(`${environment.url}/voucher/report`, { params });
  }

  rollbackReceiptPdf(creditNoteCode: string, receiptCode: string, salesOrgCode: string, branchCode: string, sellerCode: string, isVoidPayment?: boolean, searchByReceiptCode?: boolean) {
    let params = new HttpParams()
      .set("pdf", "true")
      .set("creditNote", creditNoteCode)
      .set('salesOrg', salesOrgCode)
      .set("receiptCode", receiptCode)
      .set("branchCode", branchCode)
      .set("sellerCode", sellerCode);
    params = isVoidPayment ? params.set("isVoidPayment", String(isVoidPayment)) : params;
    params = searchByReceiptCode == false ? params.set("searchByReceiptCode", String(searchByReceiptCode)) : params;
    return this.http.get<Blob>(`${environment.url}/receiptRollback`, { params });
  }

  replicateInformationLog(replicateInfoFilter: Filter<ReplicateInformationFilter>) {
    let params = new HttpParams()
      .set("pdf", "true");

    params = replicateInfoFilter.value.status ? params.append("status", replicateInfoFilter.value.status) : params;
    params = replicateInfoFilter.value.destination ? params.append("destination", replicateInfoFilter.value.destination) : params;
    params = replicateInfoFilter.value.id ? params.append("id", replicateInfoFilter.value.id) : params;
    params = replicateInfoFilter.value.collection ? params.append("collection", replicateInfoFilter.value.collection) : params;
    params = replicateInfoFilter.value.errorType ? params.append("errorType", replicateInfoFilter.value.errorType) : params;
    params = replicateInfoFilter.value.sellerCode ? params.append("sellerCode", replicateInfoFilter.value.sellerCode) : params;
    params = replicateInfoFilter.value.customerCode ? params.append("customerCode", replicateInfoFilter.value.customerCode) : params;
    params = replicateInfoFilter.value.branchCode ? params.append("branchCode", replicateInfoFilter.value.branchCode) : params;
    params = replicateInfoFilter.value.SalesOrgCode ? params.append("SalesOrgCode", replicateInfoFilter.value.SalesOrgCode) : params;
    params = replicateInfoFilter.value.startDate ? params.append("startDate", replicateInfoFilter.value.startDate) : params;
    params = replicateInfoFilter.value.endDate ? params.append("endDate", replicateInfoFilter.value.endDate) : params;
    return this.http.post<Blob>(`${environment.url}/replicateInformation/export`, {}, { params });
  }

  customerBalanceRecordPdf(customerCode: string, recordMotive: string, responsiblePosition: string, toWhom: string, cancellationAmount: number, salesOrg: string) {
    let params = new HttpParams().set("pdf", "true");
    params = params.append('customerCode', customerCode);
    params = params.append('recordMotive', recordMotive);
    params = params.append('responsiblePosition', responsiblePosition);
    params = params.append('toWhom', toWhom);
    params = params.append('cancellationAmount', `${cancellationAmount}`);
    params = params.append('salesOrg', salesOrg);

    return this.http.get<Blob>(`${environment.url}/balanceRecord`, { params });
  }

  settlementPdf(contractNumber: string, salesOrg: string, responsiblePosition: string, cancelledOn: string) {
    let params = new HttpParams().set("pdf", "true");
    params = params.append('contractNumber', contractNumber);
    params = params.append('salesOrg', salesOrg);
    params = params.append('responsiblePosition', responsiblePosition);
    params = params.append('cancelledOn', `${this.datePipe.transform(cancelledOn, "yyyyMMdd")}`);

    return this.http.get<Blob>(`${environment.url}/settlement`, { params });
  }

  invoiceRequest(invoiceCode: string) {
    let params = new HttpParams().set("pdf", "true");
    params = params.set("invoiceCode", invoiceCode);
    params = params.set("salesOrg", this.configService.readSelectedBranchAndSalesOrg().salesOrg.code);
    params = params.set("createdAt", `${this.configService.readPhysicalEstablishment().city},${this.configService.readPhysicalEstablishment().country}`)
    return this.http.get<Blob>(`${environment.url}/invoice/reprintRequest`, { params });
  }

  invoiceRequestEquipment(invoiceCode: string) {
    let params = new HttpParams().set("pdf", "true");
    params = params.set("invoiceCode", invoiceCode);
    params = params.set("salesOrg", this.configService.readSelectedBranchAndSalesOrg().salesOrg.code);

    return this.http.get<Blob>(`${environment.url}/invoiceReprint`, { params });
  }

  invoiceRequestCheckSalesOrg(invoiceCode: string) {
    const salesOrg = this.configService.readSelectedBranchAndSalesOrg().salesOrg;
    if (salesOrg.code == "1500" || salesOrg.code == "1600") {
      return this.invoiceRequestEquipment(invoiceCode);
    }
    return this.invoiceRequest(invoiceCode);
  }

  reimbursementPdf(documentNumber: string, operation: ReimbursementOperation, salesOrg: string) {
    let params = new HttpParams().set("pdf", "true");
    params = params.set("operation", operation);
    params = params.set("salesOrg", salesOrg);

    return this.http.get<Blob>(`${environment.url}/reimbursement/${documentNumber}/pdf`, { params });
  }

  insuranceRejection(insuranceRejectionCode: string, salesOrg: string) {
    let params = new HttpParams().set("pdf", "true");
    params = params.set("insuranceRejectionCode", insuranceRejectionCode);
    params = params.set("salesOrg", salesOrg);
    return this.http.get<Blob>(`${environment.url}/insuranceRejection`, { params });
  }

  creditReferencePdf(customerCode: string, toWhom: string, salesOrg: string) {
    let params = new HttpParams().set("pdf", "true");
    params = params.set("customerCode", customerCode);
    params = params.set("toWhom", toWhom);
    params = params.set("salesOrg", salesOrg);
    return this.http.get<Blob>(`${environment.url}/creditReferences/pdf`, { params });
  }
  contractCancellation(code: string) {
    const params = new HttpParams().set("contractCancellationCode", code).set("salesOrg", this.configService.readSelectedBranchAndSalesOrg().salesOrg.code).set("pdf", "true");
    return this.http.get<Blob>(`${environment.url}/contractCancellation`, { params });
  }


  refinancingReport(contractNumber: string) {
    let params = new HttpParams().set("pdf", "true");
    return this.http.get<Blob>(`${environment.url}/loans/${contractNumber}/getRefinancingPdf`, { params });
  }



}
